import { Button } from "@components/button";
import { Input } from "@components/input";
import { FlexLoader } from "@components/loader";
import { Modal } from "@components/modal";
import { CustomSelect } from "@components/select";
import { useAdminBalances } from "@features/admin/finance";
import { useForm } from "react-hook-form";

type AddWalletModalProps = {
  isModalOpen: boolean;
  hideModal: () => void;
};

type LocalForm = {
  option: string;
  wallet: string;
};

export const AddWalletModal = ({
  hideModal,
  isModalOpen,
}: AddWalletModalProps) => {
  const { control, handleSubmit } = useForm<LocalForm>();
  const {
    state,
    addAdminWalletsForWithdrawals,
    getAdminWalletsForWithdrawals,
    getAdminWallet,
    addAdminWallet,
  } = useAdminBalances();

  const options = [
    { text: "Прием", value: "Прием" },
    { text: "Отправка", value: "Отправка" },
  ];

  const submit = (data: LocalForm) => {
    if (data.option == "Отправка") {
      addAdminWalletsForWithdrawals({ wallet: data.wallet }).then(() => {
        hideModal();
        getAdminWalletsForWithdrawals();
      });
    } else {
      addAdminWallet({ wallet: data.wallet }).then(() => {
        hideModal();
        getAdminWallet();
      });
    }
  };
  return (
    <Modal
      isOpen={isModalOpen}
      onClose={hideModal}
      title={"Добавление кошелька"}
    >
      {state.isModalLoading ? (
        <FlexLoader />
      ) : (
        <form>
          <div style={{ marginBottom: "10px" }}>
            <Input control={control} label="Адрес" name="wallet"></Input>
          </div>
          <div style={{ marginBottom: "10px" }}>
            <CustomSelect
              control={control}
              options={options}
              name="option"
            ></CustomSelect>
          </div>
          <Button onClick={handleSubmit(submit)}>Сохранить</Button>
        </form>
      )}
    </Modal>
  );
};
